// extracted by mini-css-extract-plugin
module.exports = {"ls3ol83":"ls3ol83","t2rnaph":"t2rnaph","tfarh95":"tfarh95","n7s6lnh":"n7s6lnh","l2ara16":"l2ara16"};